var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddNoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#E6F6FF",
    stroke: "#03449E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.586 9.58601C19.7705 9.39499 19.9912 9.24262 20.2352 9.13781C20.4792 9.03299 20.7416 8.97782 21.0072 8.97551C21.2728 8.9732 21.5361 9.0238 21.7819 9.12437C22.0277 9.22493 22.251 9.37343 22.4388 9.56122C22.6266 9.749 22.7751 9.97231 22.8756 10.2181C22.9762 10.4639 23.0268 10.7273 23.0245 10.9928C23.0222 11.2584 22.967 11.5208 22.8622 11.7648C22.7574 12.0088 22.605 12.2295 22.414 12.414L21.621 13.207L18.793 10.379L19.586 9.58601ZM17.379 11.793L9 20.172V23H11.828L20.208 14.621L17.378 11.793H17.379Z",
    fill: "#03449E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteIcon);
export default __webpack_public_path__ + "static/media/add-note-icon.379f7ea4dd92925b7da0cc15c65594c7.svg";
export { ForwardRef as ReactComponent };